import React from "react";
import { Div } from "../../../styles/Common";

export const ModalFooter = ({ children, ...rest }) => {
  return <Div {...rest}>{children}</Div>;
};
